import { useState, useMemo } from 'react';
import { Form, Button, Col, Row, Modal, Card, Spinner } from 'react-bootstrap';
import api from '../../api/apiweb-receptoresdteweb.js';
import Rut from 'rutjs';
import actividadEconomica from '../../constants/codigos_actividad_economica.json';
import {
  FaCog,
  FaRegTrashAlt,
  FaSearch,
  FaEraser,
  FaUsers,
  FaUserPlus,
  FaExclamationTriangle,
  FaCheckCircle,
} from 'react-icons/fa';
import ModalReceptorForm from '../receptorFactura/ModalReceptorForm.jsx';
import regionesData from '../../constants/regiones_comunas.json';
import '../receptorFactura/receptorFactura.scss';

function ReceptorDteWeb(props) {
  const initialState = {
    rut: '',
    razonSocial: '',
    direccion: '',
    comuna: '',
    ciudad: '',
    giro: '',
    telefono: '',
    email: '',
    acteco: '',
  };

  const [formData, setFormData] = useState(initialState);
  const [erroresReceptor, setErroresReceptor] = useState([]);
  const [mostrarModalErrores, setMostrarModalErrores] = useState(false);
  const [loading, setLoading] = useState(false);
  const [totalResultados, setTotalResultados] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loadingMensaje, setLoadingMensaje] = useState('');
  const [errorApi, setErrorApi] = useState(null);
  const [mostrarModalErrorApi, setMostrarModalErrorApi] = useState(false);

  const [rutBusquedaError, setRutBusquedaError] = useState('');
  const [busquedaRealizada, setBusquedaRealizada] = useState(false);
  const opcionesActividad = actividadEconomica.map((item) => ({
    value: item.codigo,
    label: `${item.codigo} - ${item.nombre}`,
  }));
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showModalAgregarReceptor, setShowModalAgregarReceptor] = useState(false);
  const handleCloseSuccessModal = () => setShowSuccessModal(false);
  const [showModalEditar, setShowModalEditar] = useState(false);
  const [showModalEliminar, setShowModalEliminar] = useState(false);
  const [receptorSeleccionado, setReceptorSeleccionado] = useState(null);
  const [messageSuccess, setMessageSuccess] = useState('');
  const [sucessTitle, setSucessTitle] = useState('');
  const [filtros, setFiltros] = useState({
    rut: '',
    razon_social: '',
    ciudad: '',
    comuna: '',
  });

  const [receptores, setReceptores] = useState([]);

  const regiones = regionesData.regiones;

  const groupedRegionOptions = useMemo(() => {
    return regiones.map((r) => ({
      label: r.region,
      options: r.comunas.map((c) => ({ value: c, label: c })),
    }));
  }, [regiones]);

  const handleFiltroChange = (campo, valor) => {
    setFiltros((prev) => ({ ...prev, [campo]: valor }));
  };

  const buscarReceptores = async (page = 1) => {
    const sinDV = new Rut(filtros.rut).rut;
    filtros.rutsv = sinDV;
    setLoadingMensaje('Buscando receptores…');
    setLoading(true);

    try {
      const response = await api.getReceptores({ ...filtros, page, limit: 20 });
      const { body, totalPages, currentPage, total } = response.data;
      setTotalResultados(total || 0);
      setReceptores(body);
      setTotalPages(totalPages || 1);
      setCurrentPage(currentPage || 1);
    } catch (error) {
      console.error('Error al buscar receptores:', error.response?.data?.msg || error.message);
      setErrorApi('Error al buscar receptores: ' + (error.response?.data?.msg || error.message));
      setMostrarModalErrorApi(true);
    } finally {
      setBusquedaRealizada(true);
      setLoading(false);
    }
  };

  const limpiarFiltros = () => {
    setFiltros({ rut: '', razon_social: '', ciudad: '', comuna: '' });
  };

  const formatearTelefonoChileno = (input) => {
    if (input == null) return '';
    let numeros = input.replace(/\D/g, '');
    if (numeros === '') return '';
    if (numeros.startsWith('56')) numeros = numeros.slice(2);
    numeros = numeros.slice(0, 9);
    if (numeros === '') return '';
    if (numeros.startsWith('9')) {
      return `+56 9 ${numeros.slice(1, 5)} ${numeros.slice(5, 9)}`.trim();
    }
    return `+56 ${numeros.slice(0, 2)} ${numeros.slice(2, 9)}`.trim();
  };

  const handleLimpiarFormulario = () => {
    setFormData({ ...initialState });
    setErroresReceptor([]);
    setMostrarModalErrores(false);
  };

  const quitarTildes = (texto) =>
    (texto || '').normalize('NFD').replace(/[̀-ͯ]/g, '');

  const generarJsonEnvio = () => ({
    rut: new Rut(formData.rut).rut,
    razonsocial: formData.razonSocial,
    giro: formData.giro,
    direccion: formData.direccion,
    comuna: quitarTildes(formData.comuna).toUpperCase(),
    acteco: formData.acteco && formData.acteco.toString().trim() !== '' ? formData.acteco : null,
    ciudad: formData.ciudad,
    telefono: formData.telefono.replace(/\D/g, ''),
    email: formData.email,
  });

  const handleAgregarReceptor = async (e) => {
    e.preventDefault();
    if (!validarReceptor()) return;
    setLoadingMensaje('Agregando receptor…');
    setLoading(true);
    const jsonenvio = generarJsonEnvio();
    try {
      await api.addReceptor(jsonenvio);
      setLoading(false);
      setShowSuccessModal(true);
      setSucessTitle('Agregar Receptor');
      setMessageSuccess('Receptor agregado exitosamente.');
      setFormData(initialState);
    } catch (error) {
      setErrorApi('Error al agregar receptor: ' + error.response.data.msg);
      setMostrarModalErrorApi(true);
      setLoading(false);
      return;
    } finally {
      setShowModalAgregarReceptor(false);
    }
  };

  const handleEditarReceptor = async (e) => {
    e.preventDefault();
    if (!validarReceptor()) return;
    setLoadingMensaje('Editando receptor…');
    setLoading(true);
    const jsonenvio = generarJsonEnvio();
    try {
      await api.updateReceptor(jsonenvio);
      setLoading(false);
      setShowSuccessModal(true);
      setSucessTitle('Editar Receptor');
      setMessageSuccess('Receptor actualizado exitosamente.');
      buscarReceptores(currentPage);
      setFormData(initialState);
    } catch (error) {
      console.error('Error al editar receptor:', error);
      setErrorApi('Error al editar receptor: ' + error.message);
      setMostrarModalErrorApi(true);
      setLoading(false);
      return;
    } finally {
      setShowModalEditar(false);
    }
  };

  const handleEditReceptor = (receptor) => {
    setFormData({
      rut: new Rut(receptor.rut + '', true).getNiceRut(),
      razonSocial: receptor.razon_social,
      direccion: receptor.direccion,
      comuna: receptor.comuna,
      ciudad: receptor.ciudad,
      giro: receptor.giro,
      acteco: receptor.acteco_codigo,
      telefono: formatearTelefonoChileno(receptor.telefono),
      email: receptor.email,
    });
    setShowModalEditar(true);
  };

  const handleEliminarReceptor = async () => {
    setLoadingMensaje('Eliminando receptor…');
    if (!receptorSeleccionado) {
      console.error('No hay receptor seleccionado para eliminar.');
      return;
    }
    setLoading(true);
    try {
      await api.deleteReceptor(receptorSeleccionado.rut);
      setShowModalEliminar(false);
      setShowSuccessModal(true);
      setSucessTitle('Eliminar Receptor');
      setMessageSuccess('Receptor eliminado exitosamente.');
      buscarReceptores(currentPage);
    } catch (error) {
      console.error('Error al eliminar receptor:', error);
      setErrorApi('No se pudo eliminar el receptor.');
      setMostrarModalErrorApi(true);
    } finally {
      setLoading(false);
      setReceptorSeleccionado(null);
    }
  };

  const validarReceptor = () => {
    const receptor = formData;
    const errores = [];
    const rutValido = new Rut(receptor.rut).validate();
    if (!rutValido) errores.push('El RUT del receptor es inválido.');

    const camposObligatorios = [
      { campo: 'razonSocial', etiqueta: 'Razón Social' },
      { campo: 'direccion', etiqueta: 'Dirección' },
      { campo: 'comuna', etiqueta: 'Comuna' },
      { campo: 'ciudad', etiqueta: 'Ciudad' },
      { campo: 'giro', etiqueta: 'Giro' },
    ];

    if (receptor.razonSocial.length > 100) errores.push('Razón Social no puede superar los 100 caracteres.');
    if (receptor.giro.length > 80) errores.push('Giro no puede superar los 80 caracteres.');
    if (receptor.direccion.length > 60) errores.push('Dirección no puede superar los 60 caracteres.');
    if (receptor.comuna.length > 20) errores.push('Comuna no puede superar los 20 caracteres.');
    if (receptor.ciudad.length > 20) errores.push('Ciudad no puede superar los 20 caracteres.');

    camposObligatorios.forEach(({ campo, etiqueta }) => {
      if (!receptor[campo] || receptor[campo].trim() === '') {
        errores.push(`El campo "${etiqueta}" es obligatorio.`);
      }
    });

    if (errores.length > 0) {
      setErroresReceptor(errores);
      setMostrarModalErrores(true);
      return false;
    }
    return true;
  };

  const handleRutBusquedaChange = (e) => {
    const input = e.target.value;
    const limpio = input.replace(/[^0-9kK]/g, '');
    if (limpio === '') {
      setFiltros((prev) => ({ ...prev, rut: '' }));
      setRutBusquedaError('');
      return;
    }
    setFiltros((prev) => ({ ...prev, rut: limpio }));
  };

  return (
    <div className="ReceptorFactura ReceptorDteWeb">
      <div className="page-header page-header-row">
        <div>
          <h1 className="page-title">Receptores DTE Web</h1>
          <p className="page-subtitle">Administra los datos de receptores para emisión de facturas web</p>
        </div>
        <Button variant="primary" className="btn-add" onClick={() => setShowModalAgregarReceptor(true)}>
          <FaUserPlus className="me-2" />Agregar receptor
        </Button>
      </div>

      <Card className="search-card">
        <Card.Header className="search-card-header">
          <FaSearch className="me-2" />
          Buscar receptores
        </Card.Header>
        <Card.Body>
          <Form>
            <Row className="g-3">
              <Col md={3}>
                <Form.Group>
                  <Form.Label>RUT</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Ej: 12.345.678-9"
                    value={filtros.rut}
                    onChange={handleRutBusquedaChange}
                    isInvalid={!!rutBusquedaError}
                  />
                  <Form.Control.Feedback type="invalid">{rutBusquedaError}</Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group>
                  <Form.Label>Razón Social</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Ej: Receptor Ltda."
                    value={filtros.razon_social}
                    onChange={(e) => handleFiltroChange('razon_social', e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group>
                  <Form.Label>Ciudad</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Ej: Santiago"
                    value={filtros.ciudad}
                    onChange={(e) => handleFiltroChange('ciudad', e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group>
                  <Form.Label>Comuna</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Ej: Las Condes"
                    value={filtros.comuna}
                    onChange={(e) => handleFiltroChange('comuna', e.target.value)}
                  />
                </Form.Group>
              </Col>
            </Row>

            <div className="search-actions">
              <Button variant="primary" onClick={() => buscarReceptores(1)} disabled={loading}>
                <FaSearch className="me-2" />Buscar
              </Button>
              <Button variant="outline-secondary" onClick={limpiarFiltros} className="ms-auto">
                <FaEraser className="me-2" />Limpiar
              </Button>
            </div>
          </Form>
        </Card.Body>
      </Card>

      {busquedaRealizada && (
        <Card className="search-card mt-4">
          <Card.Header className="search-card-header">
            <FaUsers className="me-2" />
            Resultados
            {totalResultados > 0 && <span className="results-count">{totalResultados}</span>}
          </Card.Header>
          <Card.Body className="p-0">
            {loading ? (
              <div className="loading-inline">
                <Spinner animation="border" variant="primary" />
                <p>{loadingMensaje || 'Cargando…'}</p>
              </div>
            ) : receptores.length === 0 ? (
              <div className="empty-state">
                <FaUsers className="empty-state-icon" />
                <p className="empty-state-text">No se encontraron receptores con esos filtros</p>
              </div>
            ) : (
              <>
                <div className="table-responsive">
                  <table className="data-table">
                    <thead>
                      <tr>
                        <th>RUT</th>
                        <th>Razón Social</th>
                        <th>Giro</th>
                        <th>Dirección</th>
                        <th>Comuna</th>
                        <th>Ciudad</th>
                        <th>Teléfono</th>
                        <th>Email</th>
                        <th className="text-end">Acciones</th>
                      </tr>
                    </thead>
                    <tbody>
                      {receptores.map((receptor, index) => (
                        <tr key={receptor.id ?? index}>
                          <td className="rut-cell">{new Rut(receptor.rut + '', true).getNiceRut()}</td>
                          <td className="razonsocial-cell">{receptor.razon_social}</td>
                          <td>{receptor.giro}</td>
                          <td>{receptor.direccion}</td>
                          <td>{receptor.comuna}</td>
                          <td>{receptor.ciudad}</td>
                          <td>{formatearTelefonoChileno(receptor.telefono)}</td>
                          <td className="email-cell">{receptor.email}</td>
                          <td className="text-end">
                            <div className="row-actions">
                              <Button
                                variant="outline-primary"
                                size="sm"
                                title="Editar receptor"
                                onClick={() => handleEditReceptor(receptor)}
                              >
                                <FaCog />
                              </Button>
                              <Button
                                variant="outline-danger"
                                size="sm"
                                title="Eliminar receptor"
                                onClick={() => {
                                  setReceptorSeleccionado(receptor);
                                  setShowModalEliminar(true);
                                }}
                              >
                                <FaRegTrashAlt />
                              </Button>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                <div className="table-footer">
                  <span className="text-muted">
                    {totalResultados} {totalResultados === 1 ? 'receptor' : 'receptores'}
                  </span>
                  <div className="pagination-controls">
                    <Button
                      variant="outline-secondary"
                      size="sm"
                      onClick={() => buscarReceptores(currentPage - 1)}
                      disabled={currentPage === 1}
                    >
                      Anterior
                    </Button>
                    <span className="page-info">
                      Página <strong>{currentPage}</strong> de <strong>{totalPages}</strong>
                    </span>
                    <Button
                      variant="outline-secondary"
                      size="sm"
                      onClick={() => buscarReceptores(currentPage + 1)}
                      disabled={currentPage === totalPages}
                    >
                      Siguiente
                    </Button>
                  </div>
                </div>
              </>
            )}
          </Card.Body>
        </Card>
      )}

      <ModalReceptorForm
        show={showModalAgregarReceptor}
        onHide={() => {
          setShowModalAgregarReceptor(false);
          handleLimpiarFormulario();
        }}
        titulo="Agregar Receptor"
        formData={formData}
        setFormData={setFormData}
        onConfirm={handleAgregarReceptor}
        opcionesActividad={opcionesActividad}
        optionsRegion={groupedRegionOptions}
      />

      <ModalReceptorForm
        show={showModalEditar}
        onHide={() => {
          setShowModalEditar(false);
          handleLimpiarFormulario();
        }}
        titulo="Editar Receptor"
        formData={formData}
        setFormData={setFormData}
        onConfirm={handleEditarReceptor}
        opcionesActividad={opcionesActividad}
        optionsRegion={groupedRegionOptions}
      />

      <Modal show={mostrarModalErrores} onHide={() => setMostrarModalErrores(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>
            <FaExclamationTriangle className="text-warning me-2" />
            Errores en los datos
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ul className="error-list">
            {erroresReceptor.map((error, index) => (
              <li key={index}>{error}</li>
            ))}
          </ul>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setMostrarModalErrores(false)}>Cerrar</Button>
        </Modal.Footer>
      </Modal>

      <Modal show={loading} centered backdrop="static">
        <Modal.Body className="text-center py-4">
          <Spinner animation="border" variant="primary" className="mb-3" />
          <p className="modal-message m-0">{loadingMensaje}</p>
        </Modal.Body>
      </Modal>

      <Modal show={mostrarModalErrorApi} onHide={() => setMostrarModalErrorApi(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>
            <FaExclamationTriangle className="text-danger me-2" />
            Error
          </Modal.Title>
        </Modal.Header>
        <Modal.Body><p className="m-0">{errorApi}</p></Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setMostrarModalErrorApi(false)}>Cerrar</Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showSuccessModal} onHide={handleCloseSuccessModal} centered>
        <Modal.Header closeButton>
          <Modal.Title>
            <FaCheckCircle className="text-success me-2" />
            {sucessTitle}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body><p className="m-0">{messageSuccess}</p></Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={handleCloseSuccessModal}>Aceptar</Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showModalEliminar} onHide={() => setShowModalEliminar(false)} backdrop="static" centered>
        <Modal.Header closeButton>
          <Modal.Title>Confirmar eliminación</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          ¿Estás seguro de eliminar al receptor <strong>{receptorSeleccionado?.razon_social}</strong>?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModalEliminar(false)}>Cancelar</Button>
          <Button variant="danger" onClick={handleEliminarReceptor}>
            <FaRegTrashAlt className="me-2" />Eliminar
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default ReceptorDteWeb;
